import { CarouselSettings } from 'yet-another-react-lightbox/*'
import { IEventDetailData } from '../store/events/types'
import { IUserPublicInterface } from '../models/users-public/users-public.interface'

export interface IUserSignupForm {
  email: string
  username: string
  fullname: string
  newPassword: string
  c_password: string
  nationality: string
}

export enum ECompetitorTypes {
  none,
  loneRider,
  teamRider,
  guardian,
  spectator,
}

export interface IRiderSignupForm {
  email: string
  userName: string
  fullName: string
  password: string
  confirmPassword: string
  userPhoneNumber: string
  userNationality: string
  userDiscipline: string
  userDOB: string
}

export interface IVendorSignupForm {
  email: string
  userName: string
  vendorname: string
  newPassword: string
  c_password: string
  userAddress: string
  website: string
  userPhoneNumber: string
  userCategory: string
  profilePic: string
}

export type IRegisterTabsSelectData = {
  id: string
  name?: string
  label?: string
  value?: string
  horseProfilePicture?: string
}

export interface IEventDetailsUi extends IEventDetailData {}

export type ITeamMemberRoles = string

export type ICompetitorCard = {
  cardHolderName: string
  cardHolderEmail: string
  cardNumber: number
  cardType: string
  pmId: string
  expiryMonth: string
  expiryYear: string
  zipCode: string
  default: boolean
}

export type INotificationSettings = {
  newMessages: boolean
  weatherUpdates: boolean
  resultUpdates: boolean
  courseUpdates: boolean
  paymentUpdates: boolean
}

export interface ICompetitorProfileAccountForm {
  password: string
  userEmail: string
  c_password: string
  newPassword: string
  old_password: string
  cards: ICompetitorCard[]
  userAccountPrivacy: any
  userAccountNumber: string
  userNotificationsSettings: INotificationSettings
}
export interface IUserEmailUpdateAccountForm {
  password: string
  userEmail: string
  updateUserEmail: string
}
export type ILightboxProps = {
  inline?: boolean
  carouselSettings?: { [K in keyof CarouselSettings]?: CarouselSettings[K] }
  inlineStyles?: React.HTMLAttributes<HTMLDivElement>
  slides: { src: string; title?: any }[]
  visible: boolean
  onClose?: () => void
}

export type IMessageComp = {
  isError?: boolean
  className?: string
  focusOnError?: boolean
  message: string | undefined | any
}

export type Props = {
  show?: boolean
  handleModal?: any
}

export type ISelect = {
  label?: any
  value?: string
}

export interface ICountryList {
  label: string
  code: string
  value: string
  light_icon?: string
  ccode?: string
}

export type IJudgingLicence = {
  label: string
  value: string
}

export interface ICompetitorProfileDetailForm extends IUserPublicInterface {
  userForeignEndorsementFormatted: string
}

export type IRegistrationEventTabKeys =
  | 'TEAM'
  | 'HORSES'
  | 'FEES'
  | 'TICKETS'
  | 'PAPERWORK'
  | 'SIGN'
  | 'COMMENTS'
  | 'CONFIRMATION'
  | 'REGISTER'

export type IRegistrationEventTabsName =
  | 'Start'
  | 'Horses'
  | 'Fees'
  | 'Tickets'
  | 'Roles'
  | 'Sign'
  | 'Comments'
  | 'Confirm and Pay'
  | 'Register'

export type IRegistrationEventTab = { tab: IRegistrationEventTabsName; step: number }
